module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('button', {
    staticClass: "senas-video",
    attrs: {
      "aria-label": "Abrir video en lenguaje de señas"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clickBot($event)
      }
    }
  }, [_c('div', {
    staticClass: "acces-icon back-red hvr-grow"
  }, [_c('v-icon', {
    staticClass: "always-white"
  }, [_vm._v("fa fa-sign-language")])], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.modalOne) ? _c('v-dialog', {
    attrs: {
      "width": "800",
      "role": "dialog",
      "aria-label": "Video saludos en lengua de señas"
    },
    model: {
      value: (_vm.modalOne),
      callback: function($$v) {
        _vm.modalOne = $$v
      },
      expression: "modalOne"
    }
  }, [_c('v-card', {
    staticClass: "pt-3 pb-2 align-center"
  }, [(_vm.youtubeEmbed) ? _c('video-app', {
    attrs: {
      "vidTittle": _vm.vidTittle,
      "videoSize": _vm.videoSize,
      "youtubeEmbed": _vm.youtubeEmbed
    }
  }) : _vm._e(), _vm._v(" "), (_vm.videoEmbed) ? _c('video-app', {
    attrs: {
      "vidTittle": _vm.vidTittle,
      "videoSize": _vm.videoSize,
      "videoEmbed": _vm.videoEmbed
    }
  }) : _vm._e(), _vm._v(" "), _c('ui-button', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "secondary": "",
      "content": 'Ocultar video en LSC',
      "aria": 'Ocultar video en LSC'
    },
    nativeOn: {
      "click": function($event) {
        _vm.modalOne = false
      }
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "acces-bot-name back-red animated fadeIn"
  }, [_c('p', {
    staticClass: "always-white"
  }, [_vm._v("Ver video en LSC")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dcc27ec2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Accesvideo.vue
// module id = 1051
// module chunks = 1